import find from "lodash/find";
import notificationErrors from "./errors";
import notificationValidations from "./validations";
import notificationWarnings from "./warnings";

export type NotificationType = "error" | "validation" | "warning";

export interface NotificationData {
  code: string;
  developerMessage: string;
  type: NotificationType;
  undoable?: boolean;
  autoClose?: boolean;
}

const allNotificationDatas = [
  ...notificationErrors,
  ...notificationValidations,
  ...notificationWarnings,
];

export const getNotificationData = (code: string): NotificationData => {
  const notificationData = find(allNotificationDatas, (data) => data.code === code);
  if (!notificationData) {
    throw new Error(`Notification not found for code ${code}`);
  }

  return notificationData;
};
